<template>
    <div class="tax-declare-layout">
        <div class="data-area">
            <ButtonSet type="payment" />
            <DataTable
                ref="DataTable"
                :showPeriod="false"
                @onOpenInvoiceDetail="onOpenInvoiceDetail"
                @onOpenPaymentDetail="onOpenPaymentDetail"
                @onOpenTranInvoiceDetail="onOpenTranInvoiceDetail"
            />
        </div>
        <div class="side-area">
            <QuickDeclareQuerySidePanel />
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex';
import ButtonSet from '@/components/dashboard/Accounting/BusinessTax/QuickDeclareButtonSet.vue';
import DataTable from '@/components/dashboard/Accounting/BusinessTax/DataTable.vue';
import QuickDeclareQuerySidePanel from '@/components/dashboard/Accounting/BusinessTax/QuickDeclareQuerySidePanel.vue';

export default {
    components: { ButtonSet, DataTable, QuickDeclareQuerySidePanel },
    created() {
        if (!this.declarePeriod) this.$router.replace({ name: 'accounting-business-tax-quick-declare-step-1' });

        this.onClearInvoiceSelection();
        this.updateQuery({
            SearchType: 1,
            QueryType: 2,
            TaxDeclareStatus: 1,
            Foo: null,
            Bsn: null,
            Amt: null,
        });
        this.emptyData();
        this.updateData();
        this.updateDeclaredData();
    },
    computed: {
        ...mapState({
            declarePeriod: (state) => state.businessTax.declarePeriod,
            periodList: (state) => state.businessTax.periodList,
        }),
        period: {
            get() {
                return this.declarePeriod;
            },
            set(val) {
                this.setDeclarePeriod(val);
            },
        },
    },
    methods: {
        ...mapMutations({
            onClearInvoiceSelection: 'businessTax/onClearInvoiceSelection',
            setDeclarePeriod: 'businessTax/setDeclarePeriod',
            updateQuery: 'businessTax/updateQuery',
        }),
        ...mapActions({
            updateData: 'businessTax/updateData',
            updateDeclaredData: 'businessTax/updateDeclaredData',
            emptyData: 'businessTax/emptyData',
        }),
        async onNextStep() {
            try {
                await this.$confirm('請留意前幾期中，是否還有未申報的進項項目', {
                    confirmButtonText: '都已申報，下一步',
                    cancelButtonText: '我再檢查一下',
                });
                this.$router.push({ name: 'accounting-business-tax-quick-declare-step-4' });
            } catch (e) {
                console.log(e);
            }
        },

        onOpenPaymentDetail(sno) {
            this.$emit('openPayment', sno);
        },
        onOpenInvoiceDetail(sno) {
            this.$emit('openInvoice', sno);
        },
        onOpenTranInvoiceDetail(tioo) {
            this.$emit('openTranInvoice', tioo);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./common-style.scss";

</style>
